import React from 'react';
import { useLingui } from '@lingui/react/macro';

import Filters from '@rover/icons/svg/filters.svg';
import ButtonWithCountBadge from '@rover/kibble/official-patterns/ButtonWithCountBadge';

export type Props = {
  onClick: () => void;
  badgeCount?: number;
};

const AllFiltersButton = ({ onClick, badgeCount }: Props): JSX.Element => {
  const { t } = useLingui();
  return (
    <ButtonWithCountBadge
      circular
      height="48px"
      width="48px"
      aria-label={t`Open all filters`}
      onPress={onClick}
      icon={Filters}
      badgeCount={badgeCount}
      badgeTestID="all-filters-badge-count"
    />
  );
};

export default AllFiltersButton;
